import { SEOHead } from "@/components/SEOHead";
import { PartnerInquiry } from "@/components/PartnerInquiry";
import { Footer } from "@/components/Footer";
import Navigation from "@/components/Navigation";

const Partner = () => {
  return (
    <>
      <SEOHead 
        title="Partner With Us - LaunchToRevenue"
        description="Collaborate with Launch To Revenue to create value for creators worldwide. Explore partnership opportunities including co-trainings, product collaborations, and service partnerships."
        type="website"
        keywords="partnership, collaboration, business partnership, creator partnership, training partnership, product collaboration"
      />
      <Navigation />
      <main className="min-h-screen pt-16">
        <PartnerInquiry />
      </main>
      <Footer />
    </>
  );
};

export default Partner;
